import { TaskItemNodeView } from './TaskItemNodeView';
export var taskView = function taskView(api, intl, placeholder) {
  return function (node, view, getPos) {
    return new TaskItemNodeView(node, view, getPos, {
      placeholder: placeholder,
      api: api,
      intl: intl
    });
  };
};